import { RegistryDropdownView } from "../registry-dropdown-view";
import { RegistryDropdownWithAnyProps } from "./registry-dropdown-with-any.types";
import { useRegistryDropdownWithAny } from "./use-registry-dropdown-with-any";

export const RegistryDropdownWithAny: React.FC<RegistryDropdownWithAnyProps> = (props) => {
  const { loading, registryOptions, disabledRegistryOptions, activeRegistry, onActiveRegistryChange } =
    useRegistryDropdownWithAny(props);

  return (
    <RegistryDropdownView
      sx={props.sx}
      loading={loading}
      disabled={props.disabled}
      registries={registryOptions}
      disabledRegistries={disabledRegistryOptions}
      activeRegistry={activeRegistry}
      onActiveRegistryChange={onActiveRegistryChange}
    />
  );
};
